import * as React from "react";
import * as AuthStore from "../store/Auth";
import * as moment from 'moment';
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { fetchData } from '../utils';
import { Button, Select, Card, Input, message, Row, Col, Tabs } from 'antd';
import { BarsOutlined, ExperimentOutlined, CarryOutOutlined, ContainerOutlined, SearchOutlined } from '@ant-design/icons/lib';
const { Option } = Select;
const { TabPane } = Tabs;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class DataArchive extends React.Component<AuthProps>
{
    public state =
    {
            data: [],
            stateList: [],
            siteList: [],
            clientSite: false,
            statesLoaded: true,
            siteId: 0,
            loading: false,
            confirmLoading: false,
            site: { id: 0, name: '', stateName: '', stateCode: '', stateId: '' },
            state: { stateId: 0, stateName: '', stateCode: '', sites: [] },   
            states: [],
            sites: [],
            searchObj:
            {
                from: '',
                to: '',
                stateId: 0,
                state: '',
                site: 0,
                siteId: '',
                siteName: '',
                stateName: ''
             },
            showingInfoWindow: false,
            selectedPlace: { name: '' },
            activeTab: 1,
            searchText: "",
            archive: { pepfarId: '', hospitalNumber: '', phoneNumber: '', address1: '', address2: '', lga: '', stateOfResidence: '', phones: [], addresses: [] },
            showDetails: false,
        };

    async componentDidMount()
    {    
        let el = this;

        var loginForm = document.getElementById("srchDv");
        if (loginForm && loginForm !== null) {
            loginForm.addEventListener("keyup", function (event) {
                var elm = document.getElementById("searchBtnP");
                if (event.keyCode === 13 && elm) {
                    event.preventDefault();
                    elm.click();
                }
            });
        }

        let user = el.props.appUser;
        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        let sites = [];
        if (user.stateCode && user.stateCode.length > 0) {
            var statex = states.filter(s => {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0) {
                let { searchObj } = this.state;
                let state: any = states[0];
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
    }
    selectSite(value: any) {
        const { searchObj } = this.state;
        if (value) {
            searchObj.site = value.key;
            let sites: any = this.state.sites.filter(function (o: any) { return o.siteId === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj, sites });
        }
    }

    selectState(value: any) {
        var el = this;
        if (!value) {
            return;
        }

        const { searchObj } = this.state;
        searchObj.site = 0;
        if (value) {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0) {
                var state = states[0];
                el.setState({ state: state, searchObj: searchObj });
            }
        }
    }

    textChange(e: any) {
        this.setState({ searchText: e.target.value });
    }

    reset()
    {           
        this.setState({
            searchObj:
            {
                from: '',
                to: '',
                stateId: 0,
                state: '',
                site: 0,
                siteId: 0,
                siteName: '',
                stateName: ''
            },
            archive: { pepfarId: '', hospitalNumber: '', phoneNumber: '', address1: '', address2: '', lga: '', stateOfResidence: '', phones: [], addresses: [] }
        });
    }
   
    ////@ts-ignore
    async getPatient()
    {
        let el = this;
        var searchText = this.state.searchText.trim();
        var site = this.state.searchObj.site;
        if (searchText.length < 1) {
            message.error("Please provide Patient's Unique ID");
            return;
        }
        if (site < 1) {
            message.error("Please select a Facility");
            return;
        }
        var query = `/api/Jolly95/getContactDataArchives?siteId=` + site + `&id=${searchText}`;
        el.setState({ loading: true, showDetails: false });
        let archive = await fetchData(query);
        el.setState({ loading: false });
        if (archive.pepfarId.length > 0)
        {
            archive.facilityName = el.state.searchObj.siteName;
            el.setState({ archive: archive, selected: true });
            el.setState({ showDetails: true });
        }
        else {
            message.error('Client information could not be retrieved');
        }
    }

    setTab(e)
    {
        this.setState({ activeTab: e });
    }
    render() 
    {
        const { state, loading, states, searchObj, archive, showDetails, searchText} = this.state;
        let user = this.props.appUser;
        let el = this;
                
        return (
            <div style={{marginTop: '15px', padding: '20px'}}>
                <Helmet>
                    <title>CDR :: Contact Data Archives</title>
                </Helmet>    
                <div className="custom-filter-dropdown">      
                    <Row style={{ marginTop: '2px' }}>
                        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Contact Data Archives</h4>
                        </Col>
                    </Row>
                    <div className="custom-filter-dropdown">
                        <Row gutter={2} style={{ marginTop: '10px', paddingBottom: '10px' }} id="srchDv">
                            {!user.stateCode && <Col xs={24} sm={24} md={6} lg={6}>
                                <Select className="circl-radius top-10-margin"
                                    labelInValue
                                    showSearch
                                    optionFilterProp="children"
                                    disabled={loading}
                                    //@ts-ignore
                                    value={{ key: state.stateId }}
                                    style={{ width: '100%' }}
                                    placeholder="Select State"
                                    onChange={(value) => this.selectState(value)}
                                >
                                    <Option key={0} value={0}>-- Select State --</Option>
                                    {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                </Select>
                            </Col>}
                            <Col xs={24} sm={24} md={6} lg={6} style={{ marginLeft: '5px' }}>
                                <Select
                                    labelInValue className="top-10-margin"
                                    showSearch
                                    optionFilterProp="children"
                                    disabled={loading}
                                    style={{ width: '100%' }}
                                    //@ts-ignore
                                    value={{ key: searchObj.site }}
                                    placeholder="Select Site"
                                    onChange={(value) => this.selectSite(value)}
                                >
                                    <Option key={0} value={0}>-- Select Site --</Option>
                                    {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                </Select>
                            </Col>
                            <Col xs={24} sm={24} md={5} lg={5} style={{ marginLeft: '5px' }}>
                                <Input className="ant-input-lg-2 top-10-margin" style={{ width: '100%' }} placeholder="Enter PUID to Search..." value={searchText} onChange={(e) => this.textChange(e)} />
                            </Col>
                            <Col xs={24} sm={24} md={3} lg={3}>
                                <Button id="searchBtnP" disabled={loading} className="login-button lgn-bttn-2 top-10-margin" type="primary" size="large"
                                    onClick={() => this.getPatient()} style={{ float: 'left', marginLeft: '10px' }}>
                                    <SearchOutlined /> {loading ? 'Please wait...' : 'Search Patient'}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <br />
                    <div className="ul-nfo custom-filter-dropdown" style={{ display: showDetails ? 'block' : 'none' }}>
                        <div className="ant-modal-content">
                            <div className="ant-modal-header">
                                <div className="ant-modal-title">
                                    Patient Details
                            </div>
                            </div>
                            <Card className="ant-card-body pfs s-list">
                                <div className="ant-modal-body c-form" style={{ overflow: 'scroll' }}>
                                    <form className="ant-form ant-form-horizontal ul-nfo h5">
                                        <Row>
                                            <Col span={12} className="rightBorder">
                                                <div className="ant-row">
                                                    <div className="ant-col-8 padding-md">
                                                        <label>Patient ID:</label>
                                                    </div>
                                                    <div className="ant-col-16 padding-md text-align-left">
                                                        <h5>{archive.pepfarId}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <div className="ant-col-8 padding-md">
                                                        <label>Hospital Number:</label>
                                                    </div>
                                                    <div className="ant-col-16 padding-md text-align-left">
                                                        <h5>{archive.hospitalNumber}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <div className="ant-col-8 padding-md">
                                                        <label>Phone Number:</label>
                                                    </div>
                                                    <div className="ant-col-16 padding-md text-align-left">
                                                        <h5>{archive.phoneNumber ? archive.phoneNumber : ''}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <div className="ant-col-8 padding-md">
                                                        <label>Address 1:</label>
                                                    </div>
                                                    <div className="ant-col-16 padding-md text-align-left">
                                                        <h5>{archive.address1 ? archive.address1 : ''}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <div className="ant-col-8 padding-md">
                                                        <label>Address 2:</label>
                                                    </div>
                                                    <div className="ant-col-16 padding-md text-align-left">
                                                        <h5>{archive.address2 ? archive.address2 : ''}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <div className="ant-col-8 padding-md">
                                                        <label>LGA:</label>
                                                    </div>
                                                    <div className="ant-col-16 padding-md text-align-left">
                                                        <h5>{archive.lga ? archive.lga : ''}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <div className="ant-col-8 padding-md">
                                                        <label>State of Residence:</label>
                                                    </div>
                                                    <div className="ant-col-16 padding-md text-align-left">
                                                        <h5>{archive.stateOfResidence ? archive.stateOfResidence : ''}</h5>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </form>
                                </div>
                            </Card>
                            <div className="ant-modal-footer cl-ant">
                                <Tabs defaultActiveKey="1" size="large">
                                    <TabPane tab="Address Archive" key="1">
                                        <div className="ul-nfo custom-filter-dropdown pt-list overflow">
                                            <div className="ant-modal-content">
                                                <div className="ant-modal-body">
                                                    {archive.addresses.map(a => 
                                                        <div className='ant-row'>
                                                            <div className='ant-col-24 padding-md pt-details'>
                                                                <div className="ant-row">
                                                                    <div className="ant-col-6 padding-md">
                                                                        <label>Address 1:</label>
                                                                        <h5>{a.address1 }</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="ant-row">
                                                                    <div className="ant-col-6 padding-md">
                                                                        <label>Address 2:</label>
                                                                        <h5>{a.address2}</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="ant-row">
                                                                    <div className="ant-col-6 padding-md">
                                                                        <label>Date Archived:</label>
                                                                        <h5>{a.dateArchived}</h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                     )}
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tab="Phone Number Archive" key="2">
                                        <div className="ul-nfo custom-filter-dropdown pt-list overflow">
                                            <div className="ant-modal-content">
                                                <div className="ant-modal-body">
                                                    {archive.phones.map(p =>
                                                        <div className='ant-row'>
                                                            <div className='ant-col-24 padding-md pt-details'>
                                                                <div className="ant-row">
                                                                    <div className="ant-col-6 padding-md">
                                                                        <label>Phones:</label>
                                                                        <h5>{p.phoneNumber}</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="ant-row">
                                                                    <div className="ant-col-6 padding-md">
                                                                        <label>Date Archived:</label>
                                                                        <h5>{p.dateArchived}</h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>                            
            </div>
        ) 
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(DataArchive as any);

